<template>
  <div class="col-auto order-1 order-md-1">
    <a v-bind="{ href, target, title }" class="v-navbar-logo d-flex align-items-end" rel="home">
      <img src="./logo.svg" alt="3F"/>
      <span><slot></slot></span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-navbar-logo {
  font-size: 1rem;
  line-height: 1em;
  color: theme-color("dark");
  text-decoration: none;

  &:active {
    color: theme-color("primary");
  }

  img {
    width: 50px;
    height: 34px;

    @include media-breakpoint-up(lg) {
      width: 60px;
      height: 40px;
    }
  }

  span {
    display: none;

    @include media-breakpoint-up(lg) {
      display: inline;
    }
  }
}
</style>
